import { useEffect } from 'react';
import { useInventoryPageStore } from '../../store/inventoryPage';
import { InventoryFieldWrapper } from '../shared';

export function SimpleInventoryField({ field }: { field: GravityFormsField }) {
	const inventories = useInventoryPageStore.use.inventories();
	const { inventory, isLoading, error } = inventories[field.id] || {
		inventory: null,
		isLoading: false,
		error: null,
	};

	// Fetch inventory data when component mounts
	useEffect(() => {
		useInventoryPageStore.getState().fetchInventory(field.id);
	}, [field.id]);

	// Content to display when not loading or error
	const contentSection = (
		<div className="inventory-available">
			<span className="inventory-available-label">
				Inventory Available
			</span>
			<span className="inventory-available-value">{inventory}</span>
		</div>
	);

	return (
		<InventoryFieldWrapper
			field={field}
			isLoading={isLoading}
			error={error}
			contentSection={contentSection}
		/>
	);
}
